export const VIDEO_TEMPLATE_LIST_CALL = "VIDEO_TEMPLATE_LIST_CALL";

export function callVideoTemplateData(tenantId) {
  return { type: VIDEO_TEMPLATE_LIST_CALL,  payload: { tenantId } };
}
